import React from "react";
import { useWeb3 } from "../../context/Web3Context";
import { useToast } from "../common/Toast";
import { shortAddress } from "../../utils/format";
import { parseError } from "../../utils/errors";
import { APP_NAME } from "../../config/app.config";
import "./Navbar.css";

export default function Navbar() {
  const { account, isConnected, isCorrectNetwork, connect, connecting, hasWallet, disconnect } = useWeb3();
  const toast = useToast();

  const onConnect = async () => {
    if (!hasWallet) {
      toast.error("No wallet found. Open this site inside your wallet's browser.");
      return;
    }
    try {
      await connect();
      toast.success("Wallet connected.");
    } catch (e) {
      toast.error(parseError(e));
    }
  };

  return (
    <header className="topbar">
      <div className="topbar-brand">
        <img src="/logo.png" alt={APP_NAME} className="brand-logo" />
        <span className="brand-name">{APP_NAME}</span>
      </div>

      <div className="topbar-right">
        {isConnected && (
          <span
            className={`net-dot ${isCorrectNetwork ? "ok" : "warn"}`}
            title={isCorrectNetwork ? "Connected" : "Wrong network"}
          />
        )}
        {isConnected ? (
          <button className="account-pill" onClick={disconnect} title="Tap to disconnect">
            {shortAddress(account)}
          </button>
        ) : (
          <button className="btn topbar-connect" onClick={onConnect} disabled={connecting}>
            {connecting ? "…" : "Connect"}
          </button>
        )}
      </div>
    </header>
  );
}
